import { connect } from 'react-redux';
import { compose } from 'recompose';
import { bindActionCreators, Dispatch } from 'redux';

import { RootState } from '@store/reducers';
import { logout } from '@store/auth/auth.actions';
import NavBar, { NavBarProps } from './NavBar';
import { getAuthUser } from '@store/auth/auth.selector';

const mapStateToProps = (state: RootState) => ({
  currentUser: getAuthUser(state),
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      logoutRequest: logout,
    },
    dispatch,
  );

export default compose<{}, NavBarProps>(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(NavBar);
